/** @file Timeline key bindings (context `timeline`, active while focus is inside the panel). */
import type { Binding } from '@pose2d/shortcuts/types';

const at = (id: string, keys: string): Binding => ({ id: `timeline.${id}`, keys, context: 'timeline' });

/** Space plays, arrows step, Home/End jump, Delete / Mod+C / Mod+V edit keys, K keys the selected bones. */
export const bindings: Binding[] = [
  at('playPause', 'Space'), at('prevFrame', 'ArrowLeft'), at('nextFrame', 'ArrowRight'), at('firstFrame', 'Home'), at('lastFrame', 'End'),
  at('deleteKeys', 'Delete'), at('copyKeys', 'Mod+KeyC'), at('pasteKeys', 'Mod+KeyV'), at('keyBones', 'KeyK'),
];
